	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.math.Color3;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-math/ref/Color3.js
// module id = 26
// module chunks = 0